module.exports = __webpack_public_path__ + "static/media/nextdotjs.0cfb6c22.svg";